module.exports = __webpack_public_path__ + "static/media/icon_conhecimento.6ee034ad.svg";